import { Dispatch } from "react";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { UserPassportService } from "Bands/services";
import { USER_ACTIONS, IUserPassportPatchData } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { IStoreState } from "App/types";

export const dispatchGetUserPassports = (dispatch: Dispatch<any>, userId?: string) => {
  dispatch(
    getUserPassports({
      userId,
      page: 1,
      paginationKey: USER_ACTIONS.getUserPassports,
    })
  );
};

const getUserPassports = createAsyncThunk(
  USER_ACTIONS.getUserPassports,
  async (
    { userId }: { userId?: string; page: number; paginationKey: string },
    { getState, rejectWithValue }
  ) => {
    try {
      const { currentUser } = (getState() as IStoreState).auth;

      const data = await UserPassportService.getUserPassports({
        user: API_ENDPOINTS.USER(userId || currentUser?.id || ""),
      });

      return {
        [IDataKeys.userPassport]: data.userPassport,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUserPassport = createAsyncThunk(
  USER_ACTIONS.createUserPassport,
  async (passport: IUserPassportPatchData, { rejectWithValue }) => {
    try {
      const data = await UserPassportService.createUserPassport(passport);
      const id = Object.values(data?.userPassport)?.[0]?.attributes?.id;

      return { id, data };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editUserPassport = createAsyncThunk(
  USER_ACTIONS.editUserPassport,
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: IUserPassportPatchData;
    },
    { rejectWithValue }
  ) => {
    try {
      return await UserPassportService.editUserPassport(id, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteUserPassport = createAsyncThunk(
  USER_ACTIONS.deleteUserPassport,
  async (id: string, { rejectWithValue }) => {
    try {
      await UserPassportService.deleteUserPassport(id);
      return {
        path: API_ENDPOINTS.USER_PASSPORT(id),
        dataKey: IDataKeys.userPassport,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
